/**
 * This file controls and manages all popup notifications that are pushed directly into the system.
 * For more information on popups, visit {@link http://minutemailer.github.io/react-popup/}
 */

import Popup from 'react-popup';
import {dbase} from "../../../firebase";
import {showShareRecordingClipboardNotification, showShareRecordingMakePublicFailureNotification} from "../live";
import './styles.css';
import copy from 'copy-to-clipboard';

/**
 * Creates a Public Popup that can be queued into the Popup queue.
 * @param unitId
 * @param recordingId
 * @param url
 * @returns {*}
 */
export const showMakePublicPopup = (unitId, recordingId, url) => Popup.queue(Popup.register({
    title: 'Are You Sure?',
    content: 'By sharing this video, anyone with the link can view the recording. Are you sure?',
    buttons: {
        left: ['cancel'],
        right: [{
            text: 'Yes, Make Publicly Accessible',
            className: 'danger',
            action: () => {
                dbase.setRecordingPublic(unitId, recordingId)
                    .then(() => {
                        copy(url);
                        showShareRecordingClipboardNotification();
                    })
                    .catch(showShareRecordingMakePublicFailureNotification);
                Popup.close();
            }
        }]
    }
}));



// WEBPACK FOOTER //
// ./src/components/notifications/popup/index.js